import React, { Component } from 'react';

import { HashLink as Link } from 'react-router-hash-link';

import { name } from 'settings';
import { BackImage, StoreButtons } from 'C4';

import logo from 'assets/images/logo/logo_white.png';

// eslint-disable-next-line react/prefer-stateless-function
export default class EmbedView extends Component {
  render() {
    const registerSuccessful = localStorage.getItem('registerSuccessful');

    return (
      <div className="embedView">
        <BackImage id="760" darken />
        <div className="welcomeView__Wrapper">
          <div className="logoWelcome">
            <img src={logo} alt={name} />
          </div>
          <div className="welcomeView__Wrapper__Text">
            <iframe src="https://player.vimeo.com/video/706283505?h=262b4d1149&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="TheSOURCE Teaser"></iframe>
            {!registerSuccessful && (
              <Link to="/login">
                <button>Pre-register Now &gt;</button>
              </Link>
            )}
            {registerSuccessful && (
              <button>You are added to the waitlist! Start now via the app!</button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
